import actions from './actions';

// eslint-disable-next-line no-unused-vars
export const setRole = role => async (dispatch, getState) => {
  return dispatch({
    type: actions.SET_ROLE,
    value: role
  });
};
